<template src="./wheelHouseIntegration.template.html"></template>
<script>
    import moment from "moment-timezone";
    import * as axios from "axios";
    import VeeValidate from "vee-validate";
    import Vue from "vue";
    import foliomodal from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";
    Vue.use(VeeValidate);
    export default {
        components: {
            foliomodal
        },
        name: "wheelHouseIntegration",
        props: ["parentComponentName", "unitId", "propertyId", "getIntegrationList", "componentIntegrationId", "selectiveIntegrationIds", "showFinalyticAccountPanel",
            "showFinalyticAccountDetails", "mainIntegration", "isIntegratedStatus", "integrationName"],
        data() {
            return {
                wheelHouseIntegratedUsersList: [],
                modalParams: {},
                isModalVisible: false,
                clientDetails: {},
                ShowAllAccount: true,
                openWheelHouseComponent: false,
                SelectedwheelHouseUser: null,
                isDropdownOpen: false,
                showDropdown: null,
                selectedEvent: false,
                isListPushed: true,
                typeListing: '',
                // actionType: null,
                originLevel: null
            }
        },

        methods: {
            getDisabledValue() {
                let vm = this;
                let wheelhouseList = vm.wheelHouseIntegratedUsersList.filter(user => {
                    if (user.IntegrationId == vm.componentIntegrationId) {
                        return user
                    }
                })
                if (wheelhouseList.length > 0) {
                    return true
                } else {
                    return false
                }
            },
            getWheelhouseListData(wheelHouseIntegratedUser) {
                let vm = this;
                if (wheelHouseIntegratedUser.StatusId == 0 && vm.ShowAllAccount) {
                    return false
                } else if ((wheelHouseIntegratedUser.StatusId == 1 && vm.ShowAllAccount) || !vm.ShowAllAccount) {
                    return true
                }
                // else if(!ShowAllAccount){
                //     return true
                // }
            },
            SaveIntegrations(event, wheelHouseIntegratedUser, actionName) {
                let vm = this;
                wheelHouseIntegratedUser = wheelHouseIntegratedUser ? wheelHouseIntegratedUser : vm.SelectedwheelHouseUser
                // event =  vm.selectedEvent  ? vm.selectedEvent : event
                console.log("wheelHouseIntegratedUser---", event, wheelHouseIntegratedUser);
                if (event && !actionName) {
                    event.stopPropagation()
                    wheelHouseIntegratedUser.IsDefault = event.target.checked || vm.selectedEvent
                    console.log("in--wheelHouseIntegratedUser.IsDefault--", wheelHouseIntegratedUser.IsDefault);
                }
                if (actionName) {
                    wheelHouseIntegratedUser.StatusId = 1
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "SaveIntegrations",
                    params: {
                        ModuleAction: "SaveIntegrations",
                        crsId: null,
                        // ClientCode: wheelHouseIntegratedUser.Integrators_UserId, 
                        username: wheelHouseIntegratedUser.UserName,
                        // password: null,
                        statusId: wheelHouseIntegratedUser.StatusId,
                        isDefault: wheelHouseIntegratedUser.IsDefault,
                        UnitId: vm.unitId,
                        PropertyId: vm.propertyId,
                        UsersPassword: wheelHouseIntegratedUser.Password,
                        password: wheelHouseIntegratedUser.Password,
                        User_ApiKey: wheelHouseIntegratedUser.User_ApiKey,
                        RatePlanId: wheelHouseIntegratedUser.RatePlanId,
                        IntegrationId: wheelHouseIntegratedUser.IntegrationId,
                        EmailId: wheelHouseIntegratedUser.EmailId,
                        Integrators_UserId: wheelHouseIntegratedUser.Integrators_UserId,
                        PhoneNumber: wheelHouseIntegratedUser.PhoneNumber,
                        derivedRateplanId: wheelHouseIntegratedUser.derivedRateplanId,
                        Amount: wheelHouseIntegratedUser.Amount,
                        isPercentage: wheelHouseIntegratedUser.isPercentage,
                        isPositive: wheelHouseIntegratedUser.isPositive
                    },
                    callback: function (err, response) {

                        if (err) {
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error!",
                                message: "Error in updating"
                            });
                            return
                        }
                        if (response) {
                            console.log("save--", response)
                            vm.isListPushed = wheelHouseIntegratedUser.IsDefault
                            console.log("isListPushed--", vm.isListPushed)
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Saved Successfully"
                            });
                        }
                        vm.GetWheelHouseUserList();
                        vm.getIntegrationList()
                        vm.isDropdownOpen = false

                    }
                })
                vm.isModalVisible = false

            },
            inactivateConnectedwheelHouseUser(event, wheelHouseIntegratedUser) {
                let vm = this;
                event.stopPropagation()
                vm.openWheelHouseComponent = true;
                vm.isModalVisible = true;
                vm.SelectedwheelHouseUser = wheelHouseIntegratedUser;
                vm.isDropdownOpen = false
                vm.typeListing = '';
                vm.modalParams = {
                    popupTitle: `${wheelHouseIntegratedUser.IntegrationId === 5 ? 'Wheelhouse User Account' : wheelHouseIntegratedUser.IntegrationId === 6 ? 'Finalytic User Account' : 'QuickBooks User Account'}`,
                    popupMessage: "Do you want to make this user account as Inactive?",
                    isRUPopup: true,
                    yesButtontext: "Yes",
                    noButtonText: "No",
                    yesButtonCallback: vm.inactivatwheelHouseUser,
                    noButtonCallback: vm.closePopup
                }

            },
            inactivatwheelHouseUser() {
                let vm = this;
                console.log("SelectedwheelHouseUser::---:--", vm.SelectedwheelHouseUser);
                if (vm.SelectedwheelHouseUser.IntegrationId === 5) {
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "wheelHouseDeleteUser",
                        params: {
                            ModuleAction: "wheelHouseDeleteUser",
                            userDetails: vm.SelectedwheelHouseUser
                        },
                        callback: function (err, response) {

                            if (err) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "Error!",
                                    message: "Error in inactivating user"
                                });
                                return
                            }
                            if (response) {
                                console.log(response)
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "User inactivated"
                                });
                                vm.GetWheelHouseUserList();
                                vm.getIntegrationList();

                            }

                        }

                    })
                }
                // else if(vm.SelectedwheelHouseUser.IntegrationId === 6 || vm.SelectedwheelHouseUser.IntegrationId === 6){
                else {
                    let vm = this;
                    console.log("inactivate-fina--", vm.SelectedwheelHouseUser);
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "SaveIntegrations",
                        params: {
                            ModuleAction: "SaveIntegrations",
                            crsId: null,
                            // ClientCode: null,
                            username: vm.SelectedwheelHouseUser.UserName,
                            // password: null,
                            statusId: 0,
                            isDefault: vm.SelectedwheelHouseUser.IsDefault,
                            UnitId: null,      //vm.unitId,
                            PropertyId: null, // vm.propertyId,
                            UsersPassword: null,
                            User_ApiKey: vm.SelectedwheelHouseUser.User_ApiKey,
                            RatePlanId: vm.SelectedwheelHouseUser.RatePlanId,
                            IntegrationId: vm.SelectedwheelHouseUser.IntegrationId,
                            EmailId: vm.SelectedwheelHouseUser.EmailId,
                            Integrators_UserId: vm.SelectedwheelHouseUser.Integrators_UserId,
                            PhoneNumber: vm.SelectedwheelHouseUser.PhoneNumber,
                            derivedRateplanId: vm.SelectedwheelHouseUser.derivedRateplanId,
                            Amount: vm.SelectedwheelHouseUser.Amount,
                            isPercentage: vm.SelectedwheelHouseUser.isPercentage,
                            isPositive: vm.SelectedwheelHouseUser.isPositive,
                            PaymentConnectionId: vm.SelectedwheelHouseUser.PaymentConnectionId,
                            RefreshToken: vm.SelectedwheelHouseUser.RefreshToken,
                            IntegartedClientId: vm.SelectedwheelHouseUser.IntegartedClientId,
                            classid: vm.SelectedwheelHouseUser.IntegratedClassId
                        },
                        callback: function (err, response) {

                            if (err) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "Error!",
                                    message: "Error in inactivating account"
                                });
                                return
                            }
                            if (response) {
                                console.log("user fin--inactive = ", response)
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "Account is inactivated"
                                });
                            }
                            vm.GetWheelHouseUserList();
                            vm.getIntegrationList();


                        }
                    })

                }
                vm.isModalVisible = false;
            },
            createUserInWheelHouse(event, wheelHouseIntegratedUser) {
                let vm = this;
                vm.SelectedwheelHouseUser = wheelHouseIntegratedUser
                // event.stopPropagation()
                vm.isModalVisible = true
                vm.openWheelHouseComponent = true
                vm.modalParams = {
                    popupTitle: wheelHouseIntegratedUser && wheelHouseIntegratedUser.IntegrationId === 9 ? "QuickBooks User Account" : wheelHouseIntegratedUser && wheelHouseIntegratedUser.IntegrationId === 5 ? "Wheelhouse User Account" : wheelHouseIntegratedUser && wheelHouseIntegratedUser.IntegrationId === 6 ? "Finalytic User Account" : "Create wheelhouse account",
                    popupMessage: wheelHouseIntegratedUser ? "Do you want to make this user account as active?" : "Are you sure you want to create new user account",
                    isRUPopup: true,
                    yesButtontext: "Yes",
                    noButtonText: "No",
                    yesButtonCallback: vm.createUserAccountInWheelHouse,
                    noButtonCallback: vm.closePopup
                }
            },
            createUserAccountInWheelHouse() {
                let vm = this;
                if (!vm.SelectedwheelHouseUser || (vm.SelectedwheelHouseUser && vm.SelectedwheelHouseUser.IntegrationId === 5)) {
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "wheelHouseUsercreate",
                        params: {
                            ModuleAction: "wheelHouseUsercreate",
                            userDetails: vm.clientDetails,
                            SelectedwheelHouseUser: vm.SelectedwheelHouseUser
                        },
                        callback: function (err, response) {

                            if (err) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "Error!",
                                    message: vm.SelectedwheelHouseUser ? "Error in actiavting user" : "Error in creating user"
                                });
                                setTimeout(() => {
                                    vm.openWheelHouseComponent = false;
                                }, 1000);
                                return
                            }
                            if (response) {
                                console.log(response)
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: vm.SelectedwheelHouseUser ? "User Activated successfully" : "User created in wheel house"
                                });
                            }
                            vm.GetWheelHouseUserList();
                        }
                    })
                }
                // else if(vm.SelectedwheelHouseUser && vm.SelectedwheelHouseUser.IntegrationId === 6){
                else {
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "SaveIntegrations",
                        params: {
                            ModuleAction: "SaveIntegrations",
                            crsId: null,
                            // ClientCode: null,
                            username: vm.SelectedwheelHouseUser.UserName,
                            // password: null,
                            statusId: 1,
                            isDefault: vm.SelectedwheelHouseUser.IsDefault,
                            UnitId: null,      //vm.unitId,
                            PropertyId: null, // vm.propertyId,
                            UsersPassword: null,
                            User_ApiKey: vm.SelectedwheelHouseUser.User_ApiKey,
                            RatePlanId: vm.SelectedwheelHouseUser.RatePlanId,
                            IntegrationId: vm.SelectedwheelHouseUser.IntegrationId,
                            EmailId: vm.SelectedwheelHouseUser.EmailId,
                            Integrators_UserId: vm.SelectedwheelHouseUser.Integrators_UserId,
                            PhoneNumber: vm.SelectedwheelHouseUser.PhoneNumber,
                            derivedRateplanId: vm.SelectedwheelHouseUser.derivedRateplanId,
                            Amount: vm.SelectedwheelHouseUser.Amount,
                            isPercentage: vm.SelectedwheelHouseUser.isPercentage,
                            isPositive: vm.SelectedwheelHouseUser.isPositive,
                            PaymentConnectionId: vm.SelectedwheelHouseUser.PaymentConnectionId,
                            RefreshToken: vm.SelectedwheelHouseUser.RefreshToken,
                            IntegartedClientId: vm.SelectedwheelHouseUser.IntegartedClientId,
                            classid: vm.SelectedwheelHouseUser.IntegratedClassId
                        },
                        callback: function (err, response) {

                            if (err) {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "Error!",
                                    message: "Error in Activating Account"
                                });
                                return
                            }
                            if (response) {
                                console.log("user fin--active = ", response)
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "Account is Activated"
                                });
                            }
                            vm.GetWheelHouseUserList();


                        }
                    })

                }
                vm.isModalVisible = false
                vm.getIntegrationList();

            },
            closePopup(event) {
                let vm = this;
                vm.isModalVisible = false;
                event.stopPropagation();
                console.log("typeListing----", vm.typeListing);
                console.log("SelectedwheelHouseUser.Active-----", vm.SelectedwheelHouseUser);

                if (vm.typeListing === 'pushListing') {
                    vm.SelectedwheelHouseUser.IsDefault = !vm.SelectedwheelHouseUser.IsDefault;
                    console.log("vm.SelectedwheelHouseUser.IsDefault--::--", vm.SelectedwheelHouseUser.IsDefault);
                    vm.SelectedwheelHouseUser.StatusId = 1
                }
                if (vm.originLevel) {
                    vm.SelectedwheelHouseUser.Active = 1
                }
                console.log("SelectedwheelHouseUser.IsDefault-----", vm.originLevel);
                if (vm.SelectedwheelHouseUser && vm.showDropdown === vm.SelectedwheelHouseUser.IntegrationId) {
                    vm.showDropdown = null
                }
                setTimeout(() => {
                    vm.openWheelHouseComponent = false;
                }, 1000);
                vm.isDropdownOpen = false
            },
            GetClientDetailById() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetClientDetailById",
                    params: {
                        ModuleAction: "GetClientDetailById"
                    },
                    callback: function (err, response) {
                        if (response.recordsets[5].length) {
                            vm.clientDetails = response.recordsets[5][0]
                            vm.clientDetails.Email = response.recordsets[6][0].Email;
                            vm.clientDetails.PhoneNumber = response.recordsets[6][0].PhoneNumber
                        }
                        vm.GetWheelHouseUserList();
                    }
                })

            },
            GetWheelHouseUserList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_ListOfIntegrations_RU",
                    params: {
                        ModuleAction: "Get_ListOfIntegrations_RU",
                        PropertyId: vm.propertyId ? vm.propertyId : null,
                        UnitId: vm.unitId ? vm.unitId : null
                    },
                    callback: function (err, response) {
                        console.log("GetWheelHouseUserList", response)
                        if (response[0].length) {
                            vm.wheelHouseIntegratedUsersList = response[0]
                            vm.SelectedwheelHouseUser = vm.wheelHouseIntegratedUsersList.filter(element => {
                                // vm.$set(element, "IsDefault", true)
                                if (element.IntegrationId == vm.componentIntegrationId)
                                    return element

                            })[0];
                            // vm.SelectedwheelHouseUser = response[0][0]
                            // vm.$set(vm.SelectedwheelHouseUser,"IsDefault",true)
                        }
                        vm.$emit('wheelHouseUserList', vm.wheelHouseIntegratedUsersList);
                    }
                })
                setTimeout(() => {
                    vm.openWheelHouseComponent = false;
                }, 1000);
            },
            pushUnitOrReservationToWheelHouse(event, type, wheelHouseIntegratedUser) {
                let vm = this;
                if (event) {
                    event.stopPropagation()
                }
                vm.isDropdownOpen = false
                console.log("this.showDropdown----", this.showDropdown)
                console.log("this.SelectedwheelHouseUser----", vm.SelectedwheelHouseUser)

                wheelHouseIntegratedUser = wheelHouseIntegratedUser ? wheelHouseIntegratedUser : vm.SelectedwheelHouseUser;
                type = type ? type : vm.typeListing;
                if (vm.showDropdown === wheelHouseIntegratedUser.IntegrationId) {
                    vm.showDropdown = null
                }
                // vm.$set(vm.showDropdown, wheelHouseIntegratedUser.IntegrationId, false);
                if (type != "unit") {
                    if (wheelHouseIntegratedUser.CrsStatus != 3) {
                        vm.$store.dispatch("toastr", {
                            type: "warning",
                            header: "Warning!",
                            message: `${wheelHouseIntegratedUser.IntegrationId === 5 ? 'Sync unit to Wheelhouse' : wheelHouseIntegratedUser.IntegrationId === 6 ? 'Sync unit to Finalytic' : 'Sync unit to QuickBooks'}`
                        });
                        vm.isModalVisible = false
                        return
                    }
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "pushUnitOrReservationToWheelHouse",
                    params: {
                        ModuleAction: "pushUnitOrReservationToWheelHouse",
                        UnitId: vm.unitId,
                        PropertyId: vm.propertyId,
                        SelectedwheelHouseUser: wheelHouseIntegratedUser,     //vm.SelectedwheelHouseUser,         
                        syncType: type,
                        componentName: vm.parentComponentName
                    },
                    callback: function (err, response) {
                        if (err) {
                            vm.$store.dispatch("toastr", {
                                type: "Error",
                                header: "Error!",
                                message: wheelHouseIntegratedUser.IntegrationId == 5 ? "Unable to sync to Wheelhouse" : wheelHouseIntegratedUser.IntegrationId == 6 ? "Unable to sync to Finalytic" : "Unable to sync to QuickBooks"
                            });
                        }
                        else {
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: wheelHouseIntegratedUser.IntegrationId == 5 ? "Pushed to Wheelhouse" : wheelHouseIntegratedUser.IntegrationId == 6 ? "Pushed to Finalytic" : "Pushed to QuickBooks"
                            });

                            setTimeout(() => {
                                vm.GetWheelHouseUserList()
                                vm.getIntegrationList()
                            }, 5000);

                        }
                    }
                })
                vm.isModalVisible = false

            },
            redirectToWheelhouseDetail(event, wheelHouseIntegratedUser) {
                let vm = this;
                if (this.isDropdownOpen) {
                    event.preventDefault();
                    event.stopPropagation();
                    return
                }
                if (vm.parentComponentName == 'integration' && wheelHouseIntegratedUser.IntegrationId === 5) {
                    vm.$router.push("/wheelhouseIntegrationDetail");
                }
                else if (vm.parentComponentName == 'integration' && (wheelHouseIntegratedUser.IntegrationId === 6 || wheelHouseIntegratedUser.IntegrationId === 9)) {
                    // vm.$router.push({
                    //     name: "finalyticIntegrationDetail",
                    //     params: wheelHouseIntegratedUser
                    // });
                    vm.$router.push("/integrationDetail/" + wheelHouseIntegratedUser.IntegrationId+"/"+wheelHouseIntegratedUser.IntegartedClientId+"/"+null);
                }
            },
            toggleDropdown(event, id) {
                if (this.showDropdown === id) {
                    this.showDropdown = null
                }
                else {
                    this.showDropdown = id
                }
                console.log("before--showDropdown==", this.showDropdown);
                event.stopPropagation();
            },
            connectExistingAccount(event) {
                let vm = this;
                if (vm.componentIntegrationId == 9) {
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "QuickBooksAuthorization",
                        params: {
                            stateObj: {
                                url: window.location.protocol + "//" + window.location.host
                            }
                        },
                        callback: function (err, response) {
                            window.open(response)
                        }
                    })
                } else {
                    vm.showFinalyticAccountPanel(event);
                }
            },
            updatePushListing(event, wheelHouseIntegratedUser, type, level) {
                let vm = this;
                event.stopPropagation()
                vm.openWheelHouseComponent = true;
                vm.isModalVisible = true;
                vm.SelectedwheelHouseUser = wheelHouseIntegratedUser;
                vm.isDropdownOpen = false
                vm.selectedEvent = event.target.checked
                vm.typeListing = type ? type : 'pushListing'
                // vm.actionType = type;
                vm.originLevel = level;
                console.log("typp--", type, level);
                console.log("selectedEvent---:---", vm.selectedEvent, vm.SelectedwheelHouseUser, wheelHouseIntegratedUser);
                vm.modalParams = {
                    popupTitle: `${wheelHouseIntegratedUser.IntegrationId === 5 ? 'Wheelhouse Listing' : wheelHouseIntegratedUser.IntegrationId === 6 ? 'Finalytic Listing' : 'QuickBooks Listing'}`,
                    popupMessage: `Do you want to make this unit(s) ${wheelHouseIntegratedUser.IsDefault ? 'inactive' : 'active'} on this channel manager?`,
                    isRUPopup: true,
                    yesButtontext: "Yes",
                    noButtonText: "No",
                    yesButtonCallback: type ? vm.pushUnitOrReservationToWheelHouse : vm.SaveIntegrations,
                    noButtonCallback: vm.closePopup
                }
            },
            handleDropdownClick(event, isDefault) {
                if (!isDefault) {
                    event.preventDefault();
                    event.stopPropagation();
                }

            }
        },
        watch: {
            reactiveShowFinalyticAccountDetails: function () {
                console.log("showFinalyticAccountDetails: ", this.showFinalyticAccountDetails);
            },
            immediate: true,
        },

        computed: {
            reactiveShowFinalyticAccountDetails() {
                if (!this.showFinalyticAccountDetails) {
                    this.GetWheelHouseUserList();
                    console.log("comp-showFinalyticAccountDetails: ", this.showFinalyticAccountDetails)

                }
                // return this.showFinalyticAccountDetails;
            }
        },

        mounted() {
            let vm = this;

            vm.GetClientDetailById()
            $(document).click(function (e) {
                vm.isDropdownOpen = vm.isDropdownOpen ? false : vm.isDropdownOpen
                vm.showDropdown = null
            })
        }
    };
</script>